import React from 'react';
import { getStatusColor } from '@/utils/helpers';

export const StatusBadge = ({ status, size = 'sm' }) => {
  const colors = getStatusColor(status);
  const sizes = {
    xs: 'px-2 py-0.5 text-xs',
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
  };

  return (
    <span
      className={`inline-flex items-center ${colors} rounded-md font-medium ${sizes[size]}`}
      data-testid={`status-badge-${status}`}
    >
      {status.replace(/_/g, ' ').toUpperCase()}
    </span>
  );
};